import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { NotesService } from '../../services/shared/notes.service';
import { UserService } from '../../services/user.service';
import { ADMIN, CORPORATE, LOG_LEVELS, SUPER_ADMIN } from '../../util/constants';
import { MenuService } from './menu.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [MenuService]
})

export class MenuComponent implements OnInit, OnDestroy {

  count = 0;
  getNotiSubscription: Subscription;
  userType: any;
  menuItems;
  getmenuSubscription: Subscription;
  userUpdateSubscription: Subscription;

  constructor(
    private ngaugeService: NGaugeService,
    public menuService: MenuService,
    private userService: UserService,
    private logService: LogService,
    private notesService: NotesService) {
    // <span *ngIf="menuitem.name === 'System Activities'"><mat-icon  class="new_release" matTooltip="New!">new_releases</mat-icon></span>
  }

  ngOnInit() {
    this.getMenuByUserRole();
    this.updateNotifyCount();
    this.userUpdateSubscription = this.userService.userUpdated$.subscribe(res => {
      if (res !== null) {
        this.getMenuByUserRole();
      }
    });
  }

  getMenuByUserRole() {
    this.getmenuSubscription =
      this.menuService.getMenus().subscribe(res => {
        this.menuItems = res['menus'];
        const userType = this.userService.getLoggedInUserType();
        const propertyType = this.userService.getLoggedInPropertyType();
        if (propertyType !== CORPORATE) {
          this.menuItems = this.menuItems.filter(menu => menu.state !== 'helpCenter');
        }
        const findBeoMenu = this.menuItems.findIndex(menu => menu['state'] === 'cateringOptions');
        this.menuItems[findBeoMenu]['name'] =
          userType !== ADMIN && userType !== SUPER_ADMIN ? 'View Catering Options' : 'Manage Catering Options';
        if (userType !== SUPER_ADMIN) {
          this.menuItems = this.menuItems.filter(menu => menu.name !== 'Group Management');
        }
      });
  }

  updateNotifyCount() {
    const userId = this.userService.getLoggedInUserId();
    this.userType = this.userService.getLoggedInUserType();
    this.getNotiSubscription = this.notesService.getReportNotification(userId).subscribe((response: any) => {
      response = response.filter(res => res.status === 'notread');
      this.count = response.length;
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, 'Menu Component', 'On Fetch Report Notification', JSON.stringify(error));
    });
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  ngOnDestroy() {
    this.unSubscribe(this.getNotiSubscription);
    this.unSubscribe(this.getmenuSubscription);
    this.unSubscribe(this.userUpdateSubscription);
    this.menuService = null;
    this.userService = null;
    this.logService = null;
    this.notesService = null;
    this.userType = null;
    this.menuItems = null;
    this.count = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/menu/menu.component.ts